import React, { useState } from "react";

const showcaseMap = {
  oliver1: ["Oliver Peoples"],
  saint1: ["Saint-Laurent", "Dunhill", "Oliver Peoples"],
  persol: ["Persol", "Prada"],
  prada: ["Prada"],
  rayban: ["Ray Ban"],
  miu: ["Miu Miu", "Tiffany & Co."],
  montblanc: ["Mont-Blanc"],
  mix: ["MIX"],
  entrance: ["Entrance"],

  oakley: ["Oakley"],
  myty: ["MYTY"],
  brunello: ["Brunello Cucinelli", "Moncler"],
  chanel1: ["Chanel"],
  lindberg: ["Lindberg", "Moncler"],
  moncler2: ["Moncler"],
  gigi: ["Gigi Studio"],

  saint2: ["Saint Laurent"],
  gucci: ["Gucci"],
  oliver2: ["Oliver Peoples"],
  cartier: ["Cartier"],

  center: ["Oliver Peoples"],

  dexter: ["Dexter"],
  chanel2: ["Chanel"],
  chanel3: ["Chanel"],
  chanelpaul: ["Chanel", "Paul Smith"],
  bottega: ["Bottega Veneta", "Chanel", "Cazal"],
  boss1: ["Boss"],
  boss2: ["Boss"],
};

// Highlight these showcases with gray + dark hover
const grayKeys = ["miu", "persol", "myty", "moncler2", "chanel3"];

const CasesPage = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-center mb-6">Store Layout</h1>

      {selected ? (
        <div className="max-w-md mx-auto border p-4 rounded-lg shadow-md">
          <h2 className="text-lg font-semibold mb-2">Brands in this case</h2>
          <ul className="list-disc list-inside">
            {selected.map((brand, idx) => (
              <li key={idx}>{brand}</li>
            ))}
          </ul>
          <button
            onClick={() => setSelected(null)}
            className="mt-4 px-4 py-2 bg-zinc-700 text-white rounded"
          >
            Close
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-10 gap-2 max-w-7xl mx-auto text-xs">


          {/* Top row */}
          <div className="col-span-10 grid grid-cols-10 gap-2 mb-2">
            <div className="h-16" />
            {["oliver1", "saint1", "persol", "prada", "rayban", "miu", "montblanc", "mix", "entrance"].map((key) => (
              <div
                key={key}
                className={`border h-16 flex items-center justify-center text-center ${key === "entrance"
                  ? "bg-emerald-600 font-semibold"
                  : `${grayKeys.includes(key) ? "bg-zinc-300 hover:bg-zinc-400" : "hover:bg-gray-100"} cursor-pointer`
                  }`}
                onClick={() => key !== "entrance" && setSelected(showcaseMap[key])}
              >
                <div className="flex flex-col items-center">
                  {showcaseMap[key].map(line => (
                    <div key={line}>{line}</div>
                  ))}
                </div>

              </div>
            ))}
          </div>

          {/* Left column */}
          <div className="col-start-1 row-span-7 grid grid-rows-7 gap-2">
            {["oakley", "myty", "brunello", "chanel1", "lindberg", "moncler2", "gigi"].map(key => (
              <div
                key={key}
                className={`border h-20 flex items-center justify-center text-center cursor-pointer ${grayKeys.includes(key) ? "bg-zinc-300 hover:bg-zinc-400" : "hover:bg-gray-100"
                  }`}
                onClick={() => setSelected(showcaseMap[key])}
              >
                <div className="flex flex-col items-center">
                  {showcaseMap[key].map(line => (
                    <div key={line}>{line}</div>
                  ))}
                </div>

              </div>
            ))}
          </div>

          <div className="col-span-7 flex justify-center items-center mt-4 mb-2">
          </div>

          {/* Right column */}
          <div className="flex flex-col justify-between h-full col-start-10 row-span-7">
            {["saint2", "gucci", "cartier", "oliver2"].map(key => (
              <div
                key={key}
                className={`border flex-1 flex items-center justify-center text-center cursor-pointer ${key === "center" ? "" : "hover:bg-gray-100"
                  }`}
                onClick={() => key !== "center" && setSelected(showcaseMap[key])}
              >
                <div className="flex flex-col items-center">
                  {showcaseMap[key].map(line => (
                    <div key={line}>{line}</div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Bottom row */}
          <div className="col-span-9 grid grid-cols-8 gap-2 mt-2">
            <div className="h-16" />
            {["dexter", "chanel2", "chanel3", "chanelpaul", "bottega", "boss1", "boss2"].map(key => (
              <div
                key={key}
                className={`border h-16 flex items-center justify-center text-center cursor-pointer ${grayKeys.includes(key) ? "bg-zinc-300 hover:bg-zinc-400" : "hover:bg-gray-100"
                  }`}
                onClick={() => setSelected(showcaseMap[key])}
              >
                <div className="flex flex-col items-center">
                  {showcaseMap[key].map(line => (
                    <div key={line}>{line}</div>
                  ))}
                </div>

              </div>
            ))}
          </div>

        </div>
      )}
    </div>
  );
};

export default CasesPage;
